import React, {useState, useEffect} from "react";
import PortableText from "./portableText";
import * as styles from './textBanner.module.css';


function TextBanner(props) {

    let bgcolor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    return (
        <div className={styles.sectionTextBanner} style={{ backgroundColor: `${bgcolor}`}}>
            <div className={styles.sectionContent}>
                <h3>
                    <PortableText blocks={props.heading} />
                </h3>
                <div className={styles.richtext}>
                    <PortableText blocks={props.content} />
                </div>
                
                {
                    (props.ctalink) ? 
                        <div className={styles.sectionCTA}>
                            <a href={props.ctalink} className={styles.ctalink}>
                                <span>{props.ctalabel}</span>
                            </a>
                        </div>
                    : ``
                }

            </div>
        </div>
    );
}
  
export default TextBanner;